import WhatIsPassport from './WhatIsPassport'

export default WhatIsPassport
